import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MainContentService } from '../../main-content.service';
import { InitialsPipe } from '../../../pipe/initials.pipe';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, InitialsPipe],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ProductCardComponent implements OnInit {
  private router = inject(Router);
  private mainContentService = inject(MainContentService);

  projects: any[] = [];

  ngOnInit() {
    this.loadProjects();
  }

  loadProjects() {
    this.mainContentService.getProjects().subscribe({
      next: (res) => {
        this.projects = res.map((p) => ({
          title: p.name,
          subtitle: p.location,
          description: p.description,
          logoUrl: p.logoUrl,
          updatedAt: p.updatedAt
            ? new Date(p.updatedAt).toLocaleDateString()
            : '',
          link: this.slugify(p.name),
          projectId: p._id,
        }));
      },
      error: (err) => console.error('Failed to load projects:', err),
    });
  }

  getProjectInitials(name: string): string {
    if (!name) return '';
    const words = name.trim().split(' ');

    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }

  slugify(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  // ✅ One unified navigation method
  goToProduct(project: any) {
    this.router.navigate(['/content', project.link]);
    console.log('Navigating to project:', project.link);
  }
}
